import { useState, useMemo } from "react";
import {
  FACTORY_CHECKPOINT_INFORMED,
  FACTORY_SETUP,
} from "../../../api/allApi_List";
import DialogBox from "../../../components/UI/DialogBox";
import spin from "../../../assets/icons/spin.png";
import { handleErrMessage } from "../../../functions/handleErrMessage";
import MainPageLayout from "../../../layout/MainPageLayout";
import JobCardInformCard from "../components/jobCardInform/JobCardInformCard";
import useGetMultiple from "../../../CustomHooks/useAxios/useGetMultiple";
import JobCardCheckpointFilter from "../components/jobCardInform/JobCardCheckpointFilter";
import NoDataDisplay from "../../../components/UI/NoDataDisplay";

const JobCardInformedPage = () => {
  const [selectedCheckpointId, setSelectedCheckpointId] = useState("");
  const { data, isLoaded, error } = useGetMultiple([
    FACTORY_CHECKPOINT_INFORMED,
    FACTORY_SETUP,
  ]);
  const dataLength = isLoaded && !error ? (data?.[0]?.length ?? 0) : 0;

  const filteredData = useMemo(() => {
    const informedData = data?.[0] ?? [];
    if (!selectedCheckpointId) return informedData;

    return informedData.filter(
      (item) => item.checkpoint.checkpointId === Number(selectedCheckpointId),
    );
  }, [data, selectedCheckpointId]);

  return (
    <MainPageLayout
      headerConfig={{ title: "Cylinder Job Card Updates" }}
      numberOfData={dataLength}
      bgColor="bg-dBlue-100"
    >
      {isLoaded && !error ? (
        <div className="pt-3 bg-gray-50 mt-3 p-4 rounded-xl">
          {dataLength > 0 && (
            <div className="mb-3 flex justify-between items-center">
              <div>
                <h2 className="md:text-lg font-semibold">
                  Cylinder Job Card Informed Updates
                </h2>
                <p className="max-md:text-xs text-sm text-gray-500">
                  Review all informed checkpoints and track their progress.
                </p>
              </div>
              <JobCardCheckpointFilter
                setupData={data[1]}
                setSelectedCheckpointId={setSelectedCheckpointId}
              />
            </div>
          )}
          <div
            className={`overflow-auto space-y-2 mt-2 relative ${dataLength > 0 ? "h-[calc(100vh-11em)] max-lg:h-[calc(100vh-9em)]" : "h-[calc(100vh-7em)]"}`}
          >
            {filteredData.length > 0 ? (
              filteredData.map((item) => {
                return <JobCardInformCard item={item} key={item.id} />;
              })
            ) : (
              <NoDataDisplay bgColor="bg-gray-50" />
            )}
          </div>
        </div>
      ) : error ? (
        <DialogBox
          title="Error"
          message={handleErrMessage(error)}
          isErrorHandleButtons={true}
        />
      ) : (
        <DialogBox message="Loading your data" animateIcon={spin} />
      )}
    </MainPageLayout>
  );
};

export default JobCardInformedPage;
